import React from "react";

import { CollapseHeader, FormCollapse } from "components/Form";
import { FinanceSubModalSection } from "constants/settings";
import { useSectionHelper, SectionToggleState } from "hooks";

import { DefaultVendorSplits } from "./DefaultVendorSplits";

interface BusinessVendorSplitsSectionProps {
  sectionHelper: SectionToggleState;
}

export const BusinessVendorSplitsSection: React.FC<
  BusinessVendorSplitsSectionProps
> = ({ sectionHelper }) => {
  const { isOpen, onToggle } = useSectionHelper(
    sectionHelper,
    FinanceSubModalSection.VENDOR_SPLITS,
  );

  const header = <CollapseHeader title="Vendor Splits" />;

  return (
    <FormCollapse
      isOpen={isOpen}
      onToggle={onToggle}
      header={header}
      dataTour="vendorSplitsCollapse"
    >
      <DefaultVendorSplits />
    </FormCollapse>
  );
};
